import getScreenType from '@/utils/analytics/getScreenType';
import getUploadAnalyticsSettings from '@/utils/analytics/getUploadAnalyticsSettings';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction } from '@/types/analytics';

/** Send analytics for an upload intent (a file was selected, before the upload). */
const sendUploadClickAnalytics = () => {
  sendAiGenScreenActionAnalytics({
    action: AiGenScreenAction.UPLOAD_CLICK,
    screen_type: getScreenType(),
    settings: getUploadAnalyticsSettings(),
  });
};

export default sendUploadClickAnalytics;
